import { db } from "@/main";

export default {
    state: {
      zoneList: [],
    },
    mutations: {
      ADD_ZONE(state, zone) {
        state.zoneList.push(zone)
      },
      UPDATE_ZONE(state, zone) {
        let index = state.zoneList.findIndex(
          obj => obj.id == zone.id
        );
        state.zoneList.splice(index, 1, zone);
      },
      DELETE_ZONE(state, zone ) {
        let index = state.zoneList.findIndex(
          obj => obj.id == zone.id
        );
        state.zoneList.splice(index, 1);
      },
      CLEAR_ZONES(state) {
        state.zoneList = []
      }
    },
    actions: {
      getZones( { state, commit } ) {
        if( state.zoneList.length == 0 ) {
          return db.collection("zones").get().then(function(querySnapshot) {
            commit('CLEAR_ZONES')
            querySnapshot.forEach(function(doc) {
                const zone = doc.data()
                zone.id = doc.id
                let zoneTmp = state.zoneList.find( e => e.id === zone.id )
                if( !zoneTmp )                                                                
                    commit('ADD_ZONE', zone)
            });
          });
        }
      },
      addZone( { commit }, zone ) {
        return new Promise((resolve, reject) => {
          db.collection("zones")
          .add(zone)
          .then(function(docRef) {
              zone.id = docRef.id;
              commit( 'ADD_ZONE', zone )
              resolve()
          })
          .catch(function(error) {
            commit('SET_ERROR', { section: 'Zones', function: 'addZone', msg: error });
            reject()
          })
        })
      },
      updateZone( { commit }, zone ) {
        return new Promise((resolve, reject) => {
          db.collection("zones")
          .doc(zone.id)
          .update(zone)
          .then(() => {
            commit( 'UPDATE_ZONE', zone )
            resolve()
          })
          .catch(function(error) {
            commit('SET_ERROR', { section: 'Zones', function: 'updateZone', msg: error });
            reject()
          })
        })
      },
      deleteZone( { commit }, zone ) {
        return new Promise((resolve, reject) => {
          db.collection("zones")
          .doc(zone.id)
          .delete()
          .then(function() {
            commit( 'DELETE_ZONE', zone )
            resolve()
          })
          .catch(function(error) {
            commit('SET_ERROR', { section: 'Zones', function: 'deleteZone', msg: error });
            reject()
          });
        })
      },
      toggleStatusZone( { commit }, zone ) {
        zone.is_active = !zone.is_active
        return new Promise((resolve, reject) => {
          db.collection("zones")
          .doc(zone.id)
          .update({
            is_active: zone.is_active
          })
          .then(function() {
            commit( 'UPDATE_ZONE', zone )
            resolve()
          })
          .catch(function(error) {
            commit('SET_ERROR', { section: 'Zones', function: 'toggleStatusZone', msg: error });
            reject()
          });
        })
      }
    }
}
  